<div class="widget-container overlay-override-container">
	@if (isLoading$() === false) {
		<div class="form-container">
			<lib-blotter-form
				[blotterFormType$]="formType$()"
				[useCounterparty$]="false"
				[submitButtonText$]="'Analyse'"
				[submitButtonStyle$]="'primary'"
				[interbankForwardRate$]="interbankForwardRate$()"
				[isLoading$]="isApiLoading$()"
				[isLiveAnalysis$]="isLiveAnalysis$()"
				[timeZone$]="defaultTimeZone"
				[defaultDealtCurrencyCode$]="defaultDealtCurrencyCode"
				[defaultContraCurrencyCode$]="defaultContraCurrencyCode"
				[defaultBaseIsSell$]="defaultBaseIsSell"
				[defaultBaseIsDealt$]="defaultBaseIsDealt"
				[currencies$]="currenciesWithLiveRatesEnabled$()"
				[tradeDateMinDate$]="tradeDateMinDate"
				[valueDateMonthOffsetFromTradeDate$]="valueDateMonthOffsetFromTradeDate"
				(submitForm)="submitForm($event)">
				<ng-container ngProjectAs="form-footer">
					@if (showErrorMessage$() === true) {
						<p class="text-error">
							There has been an error processing your request. Please try again later.
						</p>
					}
				</ng-container>
			</lib-blotter-form>
		</div>
	}
</div>
